import { ModalStyle } from './style';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from '@chakra-ui/react';

const ModalLayout = ({ isOpen, setIsOpen, children }: any) => {
  return (
    <ModalStyle>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(!isOpen)}>
        <ModalOverlay className='modal_overlay' />
        <ModalContent className='modal_content'>
          <ModalBody>{children}</ModalBody>
        </ModalContent>
      </Modal>
    </ModalStyle>
  );
};

export default ModalLayout;
